var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui modal",attrs:{"id":"done"}},[_c('i',{staticClass:"close icon"}),_vm._v(" "),_c('div',{staticClass:"header"},[_vm._v("\r\n新增成功\r\n  ")]),_vm._v(" "),_c('div',{staticClass:"content"}),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui primary button",on:{"click":_vm.done}},[_vm._v("確定")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9310d1cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/done.vue
// module id = null
// module chunks = 